import Vue from "vue";
import axios from "axios";

import App from "./App.vue";
import filters from "./filters";

import router from "./plugins/router";
import mixins from "./plugins/mixins";
import vuetify from "./plugins/vuetify";

import { APP_MODE } from "./modules/enums";
import "./registerServiceWorker";

import store from "./store";
import Pad from "@/store/modules/pad"
store.registerModule("Pad", Pad);
/* 
import VueI18n from "vue-i18n";
Vue.use(VueI18n);
import { languages } from "./i18n/index.js";
import { defaultLocale } from "./i18n/index.js";
const messages = Object.assign(languages);
var i18n = new VueI18n({
  locale: defaultLocale,
  messages,
  silentTranslationWarn: true,
  fallbackLocale: "en",
});

import VueI18nFilter from "vue-i18n-filter";
Vue.use(VueI18nFilter); 
*/
import i18n from "@/i18n";

Vue.prototype.$devEnv = process.env.NODE_ENV == "development";
Vue.prototype.$testMode = false;
Vue.prototype.$testPhoneNo = "";

Vue.prototype.$appMode = APP_MODE.WEB;
Vue.prototype.$loginAtBegin = false;
Vue.prototype.$appLogo = require("../public/img/app-logo.png");

Vue.prototype.$GOOGLE_API_KEY = "AIzaSyD8B6SvkLFML1kaUospHnPH6UN5nzC830k";

// key of google distance matrix
Vue.prototype.$GDM_API_KEY = "AIzaSyCXVqR011qs4UAs_kjCmWkjAsOgToRciVM";

import VueGeolocationApi from "vue-geolocation-api";
Vue.use(VueGeolocationApi /*, { ...options } */);

import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
  load: {
    key: Vue.prototype.$GOOGLE_API_KEY,
    libraries: "places", // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then disable the following:
  // installComponents: true,
});

import VuetifyGoogleAutocomplete from "vuetify-google-autocomplete";
Vue.use(VuetifyGoogleAutocomplete, {
  /*
      not used as loaded with component
      apiKey: key,
    */
  vueGoogleMapsCompatibility: true,
});

import Geocoder from "@pderas/vue2-geocoder";
Vue.use(Geocoder, {
  defaultCountryCode: "CA", // e.g. 'CA'
  defaultLanguage: null, // e.g. 'en'
  defaultMode: "address", // or 'lat-lng'
  googleMapsApiKey: Vue.prototype.$GOOGLE_API_KEY,
});

import RealexHpp from "@/plugins/rxp-js-mrs.js";
//import RealexHpp from "@/plugins/rxp-js.js";
Vue.prototype.$RealexHpp = RealexHpp;

Vue.prototype.$isValidPhoneNumber = function(str) {
  // return /^[1][3,4,5,7,8][0-9]{9}$/.test(str);
  // var regex = /^\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4}) *$/;
  //var pattern = /^[\+]?[1]?[(]?[2-9]{1}\d{2}[)]?[-\s\.]?[2-9]{1}\d{2}[-\s\.]?[0-9]{4}$/im;
  const pattern = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
  return pattern.test(str);
};

Vue.prototype.$isValidEmail = function(str) {
  //return /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(str);
  const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return pattern.test(str);
};

Vue.prototype.$isValidPostal = function(str) {
  const pattern_ca = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
  const pattern_us = /^\d{5}$/;
  return pattern_ca.test(str) || pattern_us.test(str);
};

Vue.prototype.$isIsoTimeFormat = function(str) {
  const pattern = /\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z)/;
  return pattern.test(str);
};

Vue.prototype.$isSqlTimeFormat = function(str) {
  const pattern = /20\d{2}(-|\/)((0[1-9])|(1[0-2]))(-|\/)((0[1-9])|([1-2][0-9])|(3[0-1]))(\s)(([0-1][0-9])|(2[0-3])):([0-5][0-9]):([0-5][0-9])/;
  return pattern.test(str);
};

Vue.prototype.$deviceLocale = navigator.language;

import EasyRefresh from "vue-easyrefresh";
Vue.use(EasyRefresh);

import IdleVue from "idle-vue";
const eventsHub = new Vue();
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 300000, // 5 MINUTES
  //idleTime: 30000, // 1 MINUTES
  startAtIdle: false
});

Vue.config.productionTip = false;

Vue.prototype.$axios = axios;

Vue.use(filters);
Vue.mixin(mixins);

import VueGtag from "vue-gtag";
Vue.use(
  VueGtag,
  {
    config: {
      id: "G-0SKWP9S7EB"
    },
  },
  router
);

new Vue({
  router,
  i18n,
  store,
  Geocoder,
  vuetify,

  created() {
    console.log("main created");
  },

  render: h => h(App),
}).$mount("#app");
